"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerSchema = void 0;
const zod_1 = require("zod");
const FaceType_1 = require("./FaceType");
const LayerType_1 = require("./LayerType");
exports.LayerSchema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    friendlyName: zod_1.z.string().optional(),
    type: LayerType_1.LayerTypeSchema,
    face: FaceType_1.FaceTypeSchema.optional(),
    faceMirrorLayer: zod_1.z.number().optional(),
    defaultVisible: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=Layer.js.map